import { createFileRoute, redirect } from "@tanstack/react-router";
import { safeReturnPath } from "../features/auth/return-path";
import { SignInFailedPage } from "../features/auth/sign-in-failed-page";

/** Keycloak sends the browser back here with the code; the path to resume never leaves the app. */
export const Route = createFileRoute("/auth/callback")({
  beforeLoad: async ({ context }) => {
    const returnTo = safeReturnPath(await context.auth.completeSignIn());
    throw redirect({ href: returnTo, replace: true });
  },
  errorComponent: SignInFailedPage,
});
